export default "__VITE_ASSET__DqfX4$b5__"